__turbopack_context__.v({
  "close-button": "hotline-toast-module-scss-module__GcUjbG__close-button",
  "headline": "hotline-toast-module-scss-module__GcUjbG__headline",
  "image": "hotline-toast-module-scss-module__GcUjbG__image",
  "placeholder": "hotline-toast-module-scss-module__GcUjbG__placeholder",
  "root": "hotline-toast-module-scss-module__GcUjbG__root",
  "root-hidden": "hotline-toast-module-scss-module__GcUjbG__root-hidden",
  "root-mobile-hidden": "hotline-toast-module-scss-module__GcUjbG__root-mobile-hidden",
  "toast": "hotline-toast-module-scss-module__GcUjbG__toast",
});
